import { render, staticRenderFns } from "./ToneWindow.vue?vue&type=template&id=f58c6af2&scoped=true&lang=pug"
import script from "./ToneWindow.vue?vue&type=script&lang=ts"
export * from "./ToneWindow.vue?vue&type=script&lang=ts"
import style0 from "./ToneWindow.vue?vue&type=style&index=0&id=f58c6af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58c6af2",
  null
  
)

export default component.exports